export const validateFields = async values => {
  let errors = {};
    /*** Post Discharge Status */
    if (values.postdischargesincedischargephysicalvisitstoer.length < 1) {
      errors.postdischargesincedischargephysicalvisitstoer = 'Required';
      errors.notifyFormErrors = 'Post Discharge Status Tab - Post Discharge Since Discharge Physical Visits to ER - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargephysicalvisitstoer)) {
      errors.postdischargesincedischargephysicalvisitstoer = 'Required';
      errors.notifyFormErrors = 'Post Discharge Status Tab - Post Discharge Since Discharge Physical Visits to ER - Required';
      throw errors;

    } else if (values.postdischargesincedischargementalvisitstoer.length < 1) {
      errors.postdischargesincedischargementalvisitstoer = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Mental Visits to ER - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargementalvisitstoer)) {
      errors.postdischargesincedischargementalvisitstoer = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Mental Visits to ER - Required';
      throw errors;

    } else if (values.postdischargesincedischargephysicalhospadmissions.length < 1) {
      errors.postdischargesincedischargephysicalhospadmissions = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Physical Hospital Admissions - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargephysicalhospadmissions)) {
      errors.postdischargesincedischargephysicalhospadmissions = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Physical Hospital Admissions - Required';
      throw errors;

    } else if (values.postdischargesincedischargementalhospadmissions.length < 1) {
      errors.postdischargesincedischargementalhospadmissions = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Mental Hospital Admissions - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargementalhospadmissions)) {
      errors.postdischargesincedischargementalhospadmissions = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Mental Hospital Admissions - Required';
      throw errors;

    } else if (values.postdischargesincedischargetimesinjail.length < 1) {
      errors.postdischargesincedischargetimesinjail = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Times in Jail - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargetimesinjail)) {
      errors.postdischargesincedischargetimesinjail = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Times in Jail - Required';
      throw errors;

    } else if (values.postdischargesincedischargelongeststayinjail.length < 1) {
      errors.postdischargesincedischargelongeststayinjail = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Longest Stay in Jail - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargelongeststayinjail)) {
      errors.postdischargesincedischargelongeststayinjail = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Longest Stay in Jail - Required';
      throw errors;

    } else if (values.postdischargesincedischargeovernighthospstay.length < 1) {
      errors.postdischargesincedischargeovernighthospstay = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Overnight Hospital Stay - Required';
      throw errors;
    } else if (!/[0-9999.]$/g.test(values.postdischargesincedischargeovernighthospstay)) {
      errors.postdischargesincedischargeovernighthospstay = 'Required';
      errors.notifyFormErrors = 'Post Discharge Since Discharge Overnight Hospital Stay - Required';
      throw errors;
      
  }
  return errors;
};
export default validateFields;